<div class="w-full h-full overflow-auto p-4">
    @if (!periods().length && isLoading()) {
        <div class="flex items-center justify-center h-full">
            <p-progress-spinner/>
        </div>
    } @else if (!periods().length) {
        <div class="flex flex-col items-center justify-center h-40 text-center text-muted-color gap-2">
            <i class="pi pi-chart-line text-3xl! opacity-50"></i>
            <div class="font-semibold text-base">No data loaded</div>
            <div class="text-sm">Adjust parameters and click Run Report.</div>
        </div>
    } @else {
        <p-table
            #coverageTable
            [value]="pivotRows()"
            [columns]="columns()"
            [scrollable]="true"
            [frozenWidth]="'150px'"
            [loading]="isLoading()"
            scrollHeight="flex"
            showGridlines
        >
            <ng-template #emptymessage>
                <tr>
                    <td [colSpan]="columns().length">No Data available</td>
                </tr>
            </ng-template>

            <ng-template #header let-columns>
                <tr>
                    <!-- Frozen column header -->
                    <th style="min-width:10rem; width: 10rem;" pFrozenColumn class="font-bold">
                        {{ columns[0].header }}
                    </th>

                    @for (col of columns.slice(1); track col.field) {
                        <th class="text-right!">
                            {{ col.header }}
                        </th>
                    }
                </tr>
            </ng-template>

            <!-- Table Body -->
                <ng-template pTemplate="body" let-row let-columns="columns">
                    <tr>
                        <!-- Frozen column cell -->
                        <td pFrozenColumn class="font-bold">
                            {{ row.label }}
                        </td>
                        <!-- Scrollable cells -->
                        @for (column of columns.slice(1); track column.field) {
                            <td class="text-right!">
                                @if (row[column.field] != null) {

                                    @if (isVolumeCell(row[column.field])) {

                                        @if (row.metricKey === 'longCapPremium') {
                                            ${{ row[column.field].volume | number:'1.2-2' }}

                                        } @else if (isDifferenceRow(row.metricKey)) {
                                            {{ row[column.field].volume | number:'1.0-0' }}

                                        } @else {
                                            {{ row[column.field].volume | number:'1.0-0' }}
                                            @if (row[column.field].price != null) {
                                                (${{ row[column.field].price | number:'1.2-2' }})
                                            }
                                        }

                                    } @else {

                                        @if (getMetricDef(row.metricKey).valueFormat === 'percent') {
                                            {{ row[column.field] | percent:'1.0-0' }}
                                        } @else if (isDifferenceRow(row.metricKey)) {
                                            {{ row[column.field] | number:'1.0-0' }}
                                        } @else {
                                            {{ row[column.field] | number:'1.0-2' }}
                                        }

                                    }

                                }
                            </td>
                        }
                    </tr>

                    <!-- Spacer Between Rows -->
                    @if (row.addSpaceAfter) {
                        <tr>
                            <td [colSpan]="columns.length"></td>
                        </tr>
                    }
                </ng-template>
        </p-table>
    }
</div>
